import React, { VoidFunctionComponent } from "react";

interface Props {
    offerWarranty: number | undefined;
    offerWarrantyUnit: string | undefined;
    state: string | undefined;
}

export const WarrantiesLabel: VoidFunctionComponent<Props> = ({ offerWarranty, offerWarrantyUnit, state }) => {
    const getWarrantyLabel = (offerWarranty: number | undefined, offerWarrantyUnit: string | undefined, state: string | undefined) => {
        let warranty = "6 mois";
        if (offerWarranty && offerWarrantyUnit) {
            warranty = `${offerWarranty} ${offerWarrantyUnit}`;
        } else if (state?.toLowerCase() === "new") {
            warranty = "2 ans";
        }
        return `Garanties : ${warranty}`;
    };
    const warrantyLabel = getWarrantyLabel(
        offerWarranty,
        offerWarrantyUnit,
        state
    );

    return <p>{warrantyLabel}</p>;
};
